export default __webpack_public_path__ + "static/peabody-8abe3f429fab38ebf36628d61ed70e70.png";